import Button, {ButtonProps} from "../Button";
import Typography, {TypographyProps} from "../Typography";

type TextButtonProps = {
	text: string;
	textProps?: TypographyProps;
	buttonProps?: Omit<ButtonProps, "children">;
};

function TextButton({text, textProps, buttonProps}: TextButtonProps) {
	return (
		<Button {...buttonProps}>
			<Typography {...textProps}>{text}</Typography>
		</Button>
	);
}

export default TextButton;
